import React, { useState, useEffect } from "react";
import A4VG from "./components/A4VG";
import { useSelector } from "react-redux";
import A4VGV40 from "./components/A4VG - 40";
import A10VNO5X from "./components/A10VNO-5X";
import A10VO31 from "./components/A10VO-31";

const SchedeTaratura = ({ readOnly, params }) => {

  const configuration = useSelector((state) => {
    return state.configuration;
  });




  return (
    <>
      {params?.rdre === "92003" &&
        <A4VG readOnly={readOnly} data={configuration} />
      }
      {params?.rdre === "92004" &&
        <A4VGV40 readOnly={readOnly} data={configuration} />
      }

      {params?.rdre === "92735" &&
        <A10VNO5X readOnly={readOnly} data={configuration} />
      }
      {(params?.rdre === "92701" || params?.rdre === "92705" || params?.rdre === "92714" || params?.rdre === "92711" || params?.rdre === "927031" || params?.rdre === "927032") &&
        <A10VO31 name={params?.rdre === "92701" ? 'A10VO31' : params?.rdre === "92705" ? "A10VO32" : params?.rdre === "92714" ? "A10VSO32" : params?.rdre === "92711" ? "A10VSO31" : params?.rdre === "927031" ? "A10V052" : params?.rdre === "927032" ? "A10V053" : 'NB'} readOnly={readOnly} data={configuration} />
      }



    </>
  );
};

export default SchedeTaratura;
